import { Heading, MediaObject, Paragraph } from '@zillow/constellation-10';

type BenefitSectionProps = {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
};

export const BenefitSection = ({ icon, title, children }: BenefitSectionProps) => {
  return (
    <MediaObject media={icon} css={{ marginBottom: 'loose' }}>
      <Heading level={3} textStyle="heading-sm" css={{ marginBottom: 'tightest' }}>
        {title}
      </Heading>
      <Paragraph>{children}</Paragraph>
    </MediaObject>
  );
};
